import AppraiserCreate from './AppraiserCreate';
import { connect } from 'react-redux';
import {
  getAppraiserManagers, getAppraiserProfile,
  getCertificateList, getDesignationList, getStateList
} from 'actions/appraiser';

const mapStateToProps = (state) => ({
  fetchingAppraiserProfile: state.appraiser.fetchingAppraiserProfile,
  fetchingAppraiserManagers: state.appraiser.fetchingAppraiserManagers,
  fetchingStateList: state.appraiser.fetchingStateList,
});

const mapDispatchToProps = (dispatch) => ({
  getAppraiserProfile(id) {
    dispatch(getAppraiserProfile(id));
    dispatch(getAppraiserManagers());
    dispatch(getCertificateList());
    dispatch(getDesignationList());
    dispatch(getStateList());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AppraiserCreate);
